import { Settings } from '~/services/settings';

type ExternalEnrollmentSettingsKey = 'patientEnrollmentUrl' | 'hcpEnrollmentUrl';

export interface IExternalEnrollmentPath {
    /** Route prefix that is no longer served by this portal. */
    prefix: string;
    /** Settings key holding the togetherwithgsk.com URL that replaces it. */
    settingsKey: ExternalEnrollmentSettingsKey;
}

/**
 * The Patient and HCP enrollments now live on togetherwithgsk.com. The landing page buttons
 * and the external-enrollment-redirect middleware both resolve their targets from this list,
 * so a button and the route guard can never point at different places.
 */
export const externalEnrollmentPaths: IExternalEnrollmentPath[] = [
    { prefix: '/patient', settingsKey: 'patientEnrollmentUrl' },
    { prefix: '/hcp', settingsKey: 'hcpEnrollmentUrl' },
];

export type ExternalEnrollmentSettings = Pick<Settings, ExternalEnrollmentSettingsKey>;

/**
 * Returns the matching entry when the path is the root of a moved section or anything beneath
 * it, otherwise undefined. Paths such as '/patient-authorization' are left alone because the
 * prefix has to be followed by a slash or end the path.
 */
export function findExternalEnrollmentPath(path: string): IExternalEnrollmentPath | undefined {
    const normalized = path.toLowerCase().replace(/\/+$/, '');
    return externalEnrollmentPaths.find(({ prefix }) => normalized === prefix || normalized.startsWith(`${prefix}/`));
}

export function getExternalEnrollmentUrl(path: string, settings: ExternalEnrollmentSettings): string | undefined {
    const match = findExternalEnrollmentPath(path);
    return match ? settings[match.settingsKey] : undefined;
}
